import React, { memo, useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import styles from './Welcome.module.less';
import UserPortrait from './UserPortrait';
import RecommdendList from './RecommendList';
import { setWelcomeInit } from '../../actions/welcome';
import Loading from '../../components/Loading/Loading';
import { logging } from '../../actions/log';
import { welcomePopTime } from '../../constants/storageKeys';
import dayjs from 'dayjs';
import { PCStoreJsBridge } from '../../nativeapi';
import { logNative, localSetItem, localGetItem } from '../../utils/utils';

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);
const selectWelcomeData = createSelector(
  state => state.welcome,
  welcome => welcome.welcomeData,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(() => {
  const [visible, setVisible] = useState(true);
  const [isNewUser, setIsNewUser] = useState(false);
  const [showSofts, setShowSofts] = useState(false);
  const [firstGuide, setFirstGuide] = useState(false);
  const installedSoftInit = useSelector(selectLocalSoftsInit);
  const dispatch = useDispatch();
  const welcomeData = useSelector(selectWelcomeData);
  const logInfoData = useSelector(selectLogInfo);
  const [sf, setSf] = useState(false);
  const [initTime, setInitTime] = useState();
  const [showSwitch, setShowSwitch] = useState(null);

  useEffect(() => {
    setInitTime(+new Date());
  }, []);
  useEffect(() => {
    const nowTime = dayjs(+new Date()).format('YYYYMMDD');
    localSetItem(welcomePopTime, nowTime);
  }, []);
  // 判断是否是新年特变版
  useEffect(() => {
    if (!firstGuide) {
      setSf(false);
    } else {
      setSf(false);
    }
  }, [firstGuide]);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    if ((!isNewUser && !showSofts) || !visible) {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Welcome`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    }
  }, [logInfoData, isNewUser, showSofts, visible]);

  useEffect(() => {
    if (localGetItem('WELCOME_USER') === 'NO') {
      setIsNewUser(false);
    } else {
      setIsNewUser(true);
    }
    return () => {
      dispatch(
        setWelcomeInit({
          init: true,
        }),
      );
    };
  }, []);
  useEffect(() => {
    if (isNewUser && installedSoftInit && installedSoftInit.length > 0) {
      setFirstGuide(true);
    }
  }, [installedSoftInit, isNewUser]);

  const handleClose = useCallback(() => {
    // 新手引导打桩
    if (isNewUser) {
      dispatch(
        logging({
          category: 'C',
          action: 'Guide_Close',
          label: '',
          param2: {
            source: 'Guide',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    } else {
      dispatch(
        logging({
          category: 'C',
          action: 'W_Close',
          label: '',
          param2: {
            source: 'Welcome',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
    setVisible(false);

    if (showSwitch === true) {
      localSetItem('WELCOME_SHOW_88', 1);
      dispatch(
        logging({
          category: 'R',
          action: 'No_Remind',
          label: '',
          param2: {
            source: 'Welcome',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    } else if (showSwitch === false) {
      localSetItem('WELCOME_SHOW_88', 2);
    }
  }, [visible, isNewUser, showSwitch]);

  useEffect(() => {
    let userType = ['1'];
    try {
      let typeStr = localGetItem('WELCOME_USER_TYPE');
      if (typeStr) {
        userType = JSON.parse(typeStr);
      }
    } catch (err) {
      logNative(
        `解析用户欢迎页选中类型出错 Welcome WELCOME_USER_TYPE -${localGetItem(
          'WELCOME_USER_TYPE',
        )}-`,
      );
    }

    if (
      !welcomeData ||
      !userType ||
      userType.length < 1 ||
      !installedSoftInit ||
      installedSoftInit.length < 1
    ) {
      return;
    }

    let data = userType
      .map(id => {
        return (
          welcomeData.guideResultMap &&
          welcomeData.guideResultMap[id] && {
            ...welcomeData.guideResultMap[id].rankInfo,
            imgUrl: welcomeData.guideResultMap[id].imgUrl,
          }
        );
      })
      .filter(item => item); // 根据用户选择的类型排序
    // 过滤已安装的软件;
    data = data.map(item => {
      return {
        ...item,
        apps: item.apps.filter(app => {
          return !installedSoftInit.find(
            soft => app.softID === soft.SoftID || app.softID === soft.softID,
          );
        }),
      };
    });
    // 根据用户画像个数确定最后的翻页展示数据
    let bannerData = [];
    if (userType.length < 2) {
      const len = data[0] && data[0].apps.length;
      // eslint-disable-next-line radix
      let page = len % 8 === 0 ? parseInt(len / 8) : parseInt(len / 8) + 1;
      while (page > 0) {
        bannerData.unshift({
          ...data[0],
          apps: data[0].apps.slice(
            (page - 1) * 8,
            (page - 1) * 8 + 8 >= len ? len : (page - 1) * 8 + 8,
          ),
        });
        page -= 1;
      }
    } else {
      bannerData = data.map(item => ({ ...item, apps: item.apps.slice(0, 8) }));
    }
    bannerData = bannerData.filter(item => item.apps.length >= 4);
    if (Object.keys(welcomeData.guideResultMap).length > 0 && bannerData.length < 1) {
      setShowSofts(false);
    } else {
      setShowSofts(true);
    }
  }, [welcomeData, installedSoftInit]);

  // 移动窗口Mouse
  const handleWindowHtCaption = useCallback(ev => {
    ev.stopPropagation();
    if (ev.target instanceof HTMLAnchorElement || ev.target instanceof HTMLInputElement) {
      return;
    }
    PCStoreJsBridge.startMoveWindow();
  }, []);
  // 移动窗口触屏
  const handleTouchStart = useCallback(ev => {
    ev.stopPropagation();
    if (ev.target instanceof HTMLAnchorElement || ev.target instanceof HTMLInputElement) {
      return;
    }

    if (ev.targetTouches) {
      PCStoreJsBridge.touchStartWindow(ev.targetTouches[0]);
    } else {
      PCStoreJsBridge.touchStartWindow();
    }
    // PCStoreJsBridge.touchStartWindow();
  }, []);

  const handleTouchMove = useCallback(ev => {
    if (ev.targetTouches) {
      PCStoreJsBridge.touchMoveWindow(ev.targetTouches[0]);
    } else {
      PCStoreJsBridge.touchMoveWindow();
    }
    // PCStoreJsBridge.touchMoveWindow();
  }, []);

  const handleTouchEnd = useCallback(ev => {
    PCStoreJsBridge.touchEndWindow();
  }, []);

  if (
    !visible ||
    (!isNewUser && !showSofts) ||
    (welcomeData && !welcomeData.guideResultMap) ||
    (welcomeData &&
      Object.keys(welcomeData.guideResultMap).length < 1 &&
      localGetItem('WELCOME_USER') === 'NO') ||
    !installedSoftInit ||
    installedSoftInit.length < 1
  ) {
    return null;
  }

  return (
    <div
      className={styles.mask}
      onMouseDown={handleWindowHtCaption}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className={classNames(styles.popUp, { [styles.popUp_festival]: sf })}>
        <div className={sf ? styles.popUp_close_sf : styles.popUp_close}>
          {!isNewUser && (
            <span className="icon" onClick={handleClose}>
              <i className="iconfont icon-close" />
            </span>
          )}
        </div>
        {(isNewUser || showSofts) && !welcomeData && <Loading />}
        {isNewUser && (
          <UserPortrait
            handleIsNewUser={type => {
              setIsNewUser(type);
              setShowSofts(!type);
            }}
          />
        )}

        {!isNewUser && showSofts && (
          <RecommdendList
            firstGuide={firstGuide}
            handleSoftsVisble={type => {
              setShowSofts(type);
            }}
            handleShowSwitch={data => {
              setShowSwitch(data);
            }}
          />
        )}
      </div>
    </div>
  );
});
